import { render, staticRenderFns } from "./TurnTable.vue?vue&type=template&id=ebb70186&scoped=true&"
import script from "./TurnTable.vue?vue&type=script&lang=js&"
export * from "./TurnTable.vue?vue&type=script&lang=js&"
import style0 from "./TurnTable.vue?vue&type=style&index=0&id=ebb70186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb70186",
  null
  
)

export default component.exports